module.exports = __webpack_public_path__ + "static/media/icon-close.8f79cdba.svg";